function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React, { Component } from 'react';
import theme from '@marvelapp/theme';
import { Svg } from './styles';
import { patterns } from './patterns';

var Logo =
/*#__PURE__*/
function (_Component) {
  _inherits(Logo, _Component);

  function Logo() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Logo);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Logo)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      isHovered: false
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "mouseOver", function () {
      _this.setState({
        isHovered: true
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "mouseOut", function () {
      _this.setState({
        isHovered: false
      });
    });

    return _this;
  }

  _createClass(Logo, [{
    key: "render",
    value: function render() {
      var isHovered = this.state.isHovered;

      var _this$props = this.props,
          hasAnimation = _this$props.hasAnimation,
          _this$props$height = _this$props.height,
          height = _this$props$height === void 0 ? 32 : _this$props$height,
          hoverFill = _this$props.hoverFill,
          _this$props$width = _this$props.width,
          width = _this$props$width === void 0 ? 75 : _this$props$width,
          props = _objectWithoutProperties(_this$props, ["hasAnimation", "height", "hoverFill", "width"]);

      return React.createElement(Svg, _extends({
        height: height,
        onMouseEnter: this.mouseOver,
        onMouseLeave: this.mouseOut,
        viewBox: "0 0 75 32",
        width: width,
        hoverFill: hasAnimation ? 'url(#effect)' : hoverFill
      }, props), hasAnimation && React.createElement("pattern", {
        id: "effect",
        width: "1",
        height: "1",
        viewBox: "0 0 75 32",
        preserveAspectRatio: "none"
      }, React.createElement("image", {
        id: "effect-image",
        xlinkHref: patterns[isHovered ? Math.floor(Math.random() * patterns.length) : 0],
        width: width,
        height: height,
        preserveAspectRatio: "none"
      })), React.createElement("path", {
        d: "M58.6,19.4c-25.1-2-45.8,4.1-50.5,6.4c-2.6,1.2-2.8,2.7-2.4,3.5c0.3,0.6,1.6,1,2.9,0.3 c10-5.4,30.1-9.7,50-8.5c0.5,0,0.9-0.4,0.9-0.9C59.5,19.8,59.1,19.4,58.6,19.4L58.6,19.4z M64.8,11.8c-1.1,1.2-2.6,2.1-3.1,1.7 s0-1.9,0-1.9C64.2,10,69,5.9,69,2.7c0-2.9-2.6-3.8-5.3-1.1C61.5,4,59.9,7,59,10.2c-1.4,1.4-3.7,3.2-5.7,3.2c-1.1,0-1.3-0.8-1.2-1.8 c1.7,0,6.5-1.4,6.5-5.4c0-0.7-0.3-1.3-0.8-1.8c-0.5-0.5-1.1-0.7-1.8-0.6c-2.2,0-4.9,2.2-6.3,5.4C49.4,9.1,49,9,48.7,8.8 c0.4-0.8,0.6-1.6,0.9-2.4c0.3-1.7-0.4-2.7-1.7-2.5C47,3.9,46,4.7,45.7,6.4c-0.1,0.9,0.1,1.8,0.4,2.5c-0.6,1.9-3,4.2-3.8,4.1 c-0.8-0.1,0.1-3.4,0.9-5.9c0.5-0.5,0.8-1,1.1-1.7c0.2-0.5,0.1-1.1-0.4-1.3c-1.2-0.5-2.6,0.1-3.1,1.3c-0.3,0.6-0.6,1.2-0.9,1.9 c-0.7,0.8-1.7,1.9-2,1.8c-0.4-0.3,1.1-2.3,0.9-3.5c-0.1-0.9-1-1.6-1.9-1.5c-1.4,0.2-3.1,2.8-3.1,2.8c0.2-0.5,0.3-1,0.4-1.5 c-0.1-1-1.9-1.4-2.8,0.4c-0.6,1.7-1.1,3.5-1.3,5.3c-0.4,0.8-1.9,3.2-3.1,3.3c-1,0.1,0.2-4.3,0.4-4.5c0.5-0.8,1.2-2.5,1.1-3.3 c0-0.4-0.1-0.7-0.4-0.9c-0.3-0.2-0.7-0.3-1-0.2c-0.6,0.2-1.1,0.6-1.4,1.1c-0.4-0.5-1.1-0.8-1.8-0.7c-4,0.4-6.5,7.4-6.2,10.7 c0.2,1.8,1.1,2.9,2.6,2.6c1.7-0.2,3.1-2.8,3.1-2.8s0.4,2.1,2.3,1.9c1.4-0.4,2.6-1.3,3.5-2.5c0,0.1-0.1,0.2-0.1,0.4 c-0.3,1.8,2.6,1.6,2.8,0.2c0.9-6.7,3.1-9.4,3.7-9.4c0.5,0-1.4,3.1-0.3,4.4c0.9,1,2.4,0.2,3.7-0.9c-0.2,0.8-0.3,1.7-0.4,2.5 c-0.1,1.9,0.6,3.4,2.4,3.3c2.4-0.1,4.9-3.1,6.6-5.9c0.4,0.3,0.9,0.5,1.4,0.6c-0.2,0.7-0.2,1.4-0.2,2c0.1,2.2,1.6,3,3.4,2.9 c2-0.1,4.4-1.6,6-3.1c0,0.1,0,0.2-0.1,0.2c-0.1,1.1,0.1,3,1.6,3.1c1.7,0.1,4.7-1.6,6.2-3.5C67,12,65.7,10.8,64.8,11.8L64.8,11.8 L64.8,11.8z M66.4,2.8c0.2,0,0.3,0.2,0.3,0.4c0,1.9-4.6,5.8-4.6,5.8S65.1,2.8,66.4,2.8L66.4,2.8z M55.2,6.7c0.2,0,0.3,0,0.4,0.2 s0.1,0.3,0.1,0.4c0,1.1-1.4,1.9-3,1.9C53.6,7.9,54.5,6.7,55.2,6.7L55.2,6.7z M24.2,9.6c-0.1,1.1-2.1,6.2-3.1,6.2 c-1.3,0.1,0.7-7.1,2.8-7.1C24.3,8.7,24.3,9,24.2,9.6L24.2,9.6z M7.3,11c1.3,0-1.1,6.7-0.8,9.6s3.5,2.1,3.3,0.4 C9.4,18.1,11.4,9,13.3,9c1.4,0-1.6,6.2-1,10.1c0.4,2.5,3.8,1.8,3.4,0.1c-1.1-5.1,2.5-10,2-13.6c-0.2-1.5-1.1-2.3-2-2.3 c-3.2,0-5.8,6.6-5.8,6.6S10.3,6.2,7.6,6C3.8,5.8-0.1,15.4,0,24.1c0.1,2.8,3.5,2.3,3.3,0.1C3.1,20.3,5.3,11,7.3,11L7.3,11z"
      }));
    }
  }]);

  return Logo;
}(Component);

Logo.defaultProps = {
  theme: theme,
  fill: 'currentColor',
  hasAnimation: false,
  hoverFill: 'currentColor'
};
export default Logo;